export const UserType = Object.freeze({
  introducer: 'introducer',
  business: 'business',
  lender: 'lender',
  introducerTeam: 'INTRODUCER_TEAM',
  capitalReport: 'CAPITAL_REPORT',
  xero: 'xero',
});

export function isValid(type) {
  return Object.values(UserType).find(type);
}
